import Serializable from "@/core/misc/mixins/Serializable";
import RpcMeta from "@/core/services/Rpc/RpcMeta";
import type TimeZone from "@/domains/TimeZones/TimeZone";
import type RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import type RpcDataSort from "@/core/services/Rpc/RpcDataSort";

class RpcRequest extends Serializable {

	method: string;
	id: string;
	params: Record<string, unknown> = {};
	meta: RpcMeta = null!;

	static fromRpcService(
		id: string,
		method: string,
		params: Record<string, unknown>,
		sessionToken: string | null,
		pagination: Partial<RpcDataPagination> | null,
		sort: Partial<RpcDataSort> | null,
		timeZone: TimeZone
	): RpcRequest {
		const obj = new this();

		obj.id = id;
		obj.method = method;
		obj.params = params;

		obj.meta = RpcMeta.fromRequest(sessionToken, pagination, sort, timeZone);

		return obj;
	}

	toSentryContext(): Record<string, unknown> {
		return {
			method: this.method,
			id: this.id,
			params: this.#sanitizeParams(this.params),
			meta: this.meta?.toSentryContext?.() || this.meta
		};
	}

	#sanitizeParams(params: Record<string, unknown>): Record<string, unknown> {
		if (!params || typeof params !== 'object') {
			return params;
		}

		const sanitized = { ...params };

		// TODO переделать на массив когда загрузка множества файлов
		// скрываем тело файла чтобы не хранить ненужное
		if (this.method.startsWith('files') && sanitized.file) {
			(sanitized.file as Record<string, unknown>).data = '[FILTERED]';
		}

		// Скрываем поля с password в названии
		Object.keys(sanitized).forEach(key => {
			if (key.toLowerCase().includes('password')) {
				sanitized[key] = '[FILTERED]';
			}
		});

		return sanitized;
	}

	toJSON() {
		const base = super.toJSON();
		// есть желание получать именно в таком порядке поля объекта, поэтому пересобираем как нам надо
		return {
			id: base.id,
			jsonrpc: base.jsonrpc,
			method: base.method,
			params: base.params,
			x_meta: base.meta, // через префикс мета на фронте сделана чтобы в девтулзах не лезла в глаза и была последней
		};
	}
}

export default RpcRequest;